import { Link } from "react-router-dom";
import { TableCell, Tooltip, Typography } from "@mui/material";

import useRouteMatchURL from "../../../../../Components/hooks/useRouteMatchURL";
import { roundToPrecision } from "../../../../../utils/numbers";
import AgentStatus from "../../../Clusters/Table/AgentStatus";
import ClusterType from "../../../Clusters/Table/ClusterType";
import { type DashboardCluster } from "../../../types";
import { clusterHasPsData } from "../../../utils";
import { useClusterDashboardContext } from "./context";

interface Fsk8sClusterTableRowProps {
  row: DashboardCluster;
}

const Fsk8sClusterTableRow = ({ row }: Fsk8sClusterTableRowProps) => {
  const routeMatchUrl = useRouteMatchURL();
  const { timeRange } = useClusterDashboardContext();

  const calculatedPotentialSavings = (row.potentialSavings / row.perfectscaleCost) * row.cost || 0;
  const tooltipText = "We are collecting data for this cluster. This can take up to 24 hours";
  const agentIsNew = !clusterHasPsData(row);

  const renderPerfectScaleCells = () => {
    if (agentIsNew || !row.hasDataForSelectedTimeRange) {
      return (
        <>
          <TableCell align="right">{agentIsNew ? "N/A" : `$${roundToPrecision(row.cost, 2)}`}</TableCell>
          <TableCell align="right">N/A</TableCell>
          <TableCell align="right">N/A</TableCell>
          <TableCell align="right">N/A</TableCell>
          <TableCell align="right">N/A</TableCell>
        </>
      );
    }

    return (
      <>
        <TableCell align="right">${roundToPrecision(row.cost, 2)}</TableCell>
        <TableCell align="right">${roundToPrecision(calculatedPotentialSavings, 2)}</TableCell>
        <TableCell align="right">{row.workloads}</TableCell>
        <TableCell align="right">{roundToPrecision(row.cpuRequests, 4)}</TableCell>
        <TableCell align="right">{roundToPrecision(row.memRequests, 1)} Mi</TableCell>
      </>
    );
  };

  return (
    <>
      <TableCell>
        {!agentIsNew ? (
          <Typography
            component={Link}
            to={`${routeMatchUrl}?cluster=${row.doitCluster?.id}&timeRange=${timeRange}`}
            color="inherit"
            variant="body2"
            sx={{ textDecorationColor: "inherit", cursor: "pointer" }}
          >
            {row.name}
          </Typography>
        ) : (
          <Tooltip title={tooltipText}>
            <Typography color="textDisabled" variant="body2">
              {row.name}
            </Typography>
          </Tooltip>
        )}
      </TableCell>
      <TableCell>
        <ClusterType type={row.cloud} />
      </TableCell>
      <TableCell>{!!row.doitCluster && <AgentStatus cluster={row.doitCluster} />}</TableCell>
      {renderPerfectScaleCells()}
    </>
  );
};

export default Fsk8sClusterTableRow;
